// The sign-in pages. Their close button goes back to the last page shown that is not one
// of them.
export const AUTH_PAGE_NAMES = [
  'LoginPage',
  'SignupPage',
  'ConfirmPage',
  'PasswordRecoveryPage',
  'PasswordResetPage',
  'EmailVerificationPage',
];

// ================ Action types ================ //

export const LOCATION_CHANGED = 'app/routing/LOCATION_CHANGED';

// ================ Reducer ================ //

const initialState = {
  currentLocation: null,
  currentCanonicalPath: null,
  // The last page the visitor saw that is not a sign-in page (path, search and hash)
  lastPageOutsideAuth: null,
};

export default function routingReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case LOCATION_CHANGED:
      return {
        ...state,
        currentLocation: payload.location,
        currentCanonicalPath: payload.canonicalPath,
        ...(payload.remember
          ? {
              lastPageOutsideAuth: `${payload.location.pathname}${payload.location.search ||
                ''}${payload.location.hash || ''}`,
            }
          : {}),
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

// `remember`: the page was shown and is not a sign-in page
export const locationChanged = (location, canonicalPath, remember = false) => ({
  type: LOCATION_CHANGED,
  payload: { location, canonicalPath, remember },
});

// ================ Selectors ================ //

export const selectLastPageOutsideAuth = state => state.routing?.lastPageOutsideAuth || null;
